import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let AvatarComp;

class Avatar extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: AvatarComp };
    }


    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/avatar-comp" */
            "../../../components/javascript/zcat-components/avatar-comp"
        ).then(function(res) {
            AvatarComp = res.AvatarComp;
        }));

        
;
    }
}

export {Avatar};

